import { ClientInferRequest } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { translateApiError } from "#app/i18n/translateApiError";
import { ApiError } from "#shared/infra/apiError";

type UpdateMaterialLayoutDto = ClientInferRequest<typeof contract.materialLayouts.update>["body"];

export const updateMaterialLayout = async ({
  id,
  payload,
}: {
  id: string | undefined;
  payload: UpdateMaterialLayoutDto;
}) => {
  if (!id) {
    return;
  }

  const response = await api.materialLayouts.update.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  if (response.status >= 400) {
    throw new ApiError(translateApiError(response.body), response.status, response.body);
  }

  throw new ApiError("Failed to update MaterialLayout", response.status, response.body);
};
